module.exports = __webpack_public_path__ + "img/userEquity3.48b2fba1.png";